import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

// components
import {
  Button,
  FormGroup,  
  Input,  
  Modal,
  Row,
  Col,
} from "reactstrap";
import Select from 'react-select'
import moment from "moment";

// services
import { showMessage } from "../../services/message.js";
import { getSessionCookie} from "../../services/session.js";

//Helpers
import { formateDateApi } from "../../helpers/formats.js";

//API
import { api_GET, api_POST } from "../../services/api_service.js";

export default function ModalAdicionarInconformidade({stateModalInconformidade, ordemColeta, item, handleReturn, showLoading}) {
    const session = getSessionCookie(); 

    const { register, handleSubmit, errors, setError, setValue, getValues, clearErrors } = useForm({ mode: "onBlur" });

    const [stateModal, setstateModal] = React.useState(stateModalInconformidade);

    // Inconformidade
    const [optionsInconformidade, setoptionsInconformidade] = React.useState([]);
    const [inconformidade, setInconformidade] = React.useState(null);
    const loadOptionsInconformidade = () => {        
        if (ordemColeta == null)
            return;
        api_GET(`Justificativa/GetByInconformidade/${ordemColeta.modalidadeColetaId}`).then(result => {            
            if (result.status !== 200) {
              showMessage("Aviso", result.message, 'error', null);
            }
            else{
                setoptionsInconformidade(result.data);
            }
          });
    }

    useEffect(() => {         
        setanexo(null);
        setstateModal(stateModalInconformidade);
        loadOptionsInconformidade();
    }, [stateModalInconformidade]);

    useEffect(() => {    
        if (item == null)
            return;

        showLoading(true);
        api_POST(`GeoCoding/GetEndereco`, {latitude: item.lat, longitude: item.lng}).then(result => {
            showLoading(false);
            if (result.status !== 200) {
                showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
            }
            else {
                try {
                    setValue("endereco", result?.data?.enderecoFormatado);
                }
                catch {
                    showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
                }
            }
        });
                   
    }, [item]);

    const [anexo, setanexo] = React.useState(null);
    const handleAnexo = (event) => {        
        if (event.target.files.length) {                
            var reader = new FileReader();
            let _file = event.target.files[0];
            reader.readAsDataURL(_file); 
            reader.onloadend = function() {
                var base64data = reader.result;                                    
                setanexo({
                    base64: base64data.split(',')[1], 
                    name: uuidv4() + '.' + _file.name.split('.').pop().toLowerCase()
                });                
            }                
        }
    }

    const handleAddInconformidade = () => {
        let data = getValues();
        if (inconformidade == null){
            showMessage("Aviso", "Selecione a inconformidade", 'error', null);
            return;
        }

        let json_post = {
            ordemColetaId: ordemColeta.ordemColetaId,
            tipoInconsistencia: "Outros",
            dadosAdicionais: data.descricaoInconformidade,
            registroManual: true,
            latitude: item.lat,
            longitude: item.lng,
            categoria: "Inconformidade",
            usuarioId: session.usuarioId,
            dataHoraInconsistencia: formateDateApi(moment(new Date())),            
            situacao: "Aguardando Justificativa",
            usuarioAtualizacaoId: session.usuarioId,
            justificativaId: inconformidade != null ? inconformidade.justificativaId : null,
            ordemColetaContestacao: [{
                observacoes: data.descricaoContestacao,
                usuarioId: session.usuarioId,
                anexo: anexo != null ? anexo.name : null,
                anexoBase64: anexo != null ? anexo.base64 : null,
                usuarioAtualizacaoId: session.usuarioId,
            }]
        }

        showLoading(true)
        api_POST('AvaliacaoColeta/AdicionarInconformidade', json_post).then(result => {            
            showLoading(false);
            if (result.status !== 200) {
              showMessage("Aviso", result.message, 'error', null);
            }
            else{
                showMessage("Atenção", "Inconformidade incluída na Ordem de Serviço!", 'success' , function(){handleReturn(result.data)});
            }
          });
    }


    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"                
            >     
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                    Nova Inconformidade
                    </h4>
                    <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"   
                    onClick={() => handleReturn()}                 
                    >
                    <span aria-hidden={true}>×</span>
                    </button>
                </div>           
                <div className="modal-body">                                           
                    <Row className="mt-2">
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Endereço
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="endereco"                                    
                                    type="text"                                    
                                    disabled="true"
                                    innerRef={register()}
                                />                                
                            </FormGroup>
                        </Col> 
                        <Col md="12" lg="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Inconformidade
                                </label>
                                <Select
                                    name="inconformidade"
                                    options={optionsInconformidade}
                                    getOptionLabel={({descricao}) => descricao}
                                    getOptionValue={({justificativaId}) => justificativaId} 
                                    onChange={(value) => {setInconformidade(value)}}
                                    value={inconformidade != null && optionsInconformidade.find(obj => obj.justificativaId === inconformidade.justificativaId)}
                                    placeholder="Selecione"                                    
                                />                                
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Dados Adicionais
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="descricaoInconformidade"
                                    placeholder="Descrição"
                                    type="text"  
                                    innerRef={register({ required: false})}
                                />                                
                                {errors.descricaoInconformidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col> 
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Ação a ser executada
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="descricaoContestacao"
                                    placeholder="Descrição"
                                    type="text"  
                                    innerRef={register({ required: false})}
                                />                                
                                {errors.descricaoContestacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col> 
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Importar Arquivo
                                </label>
                                <Input
                                    className="form-control-alternative"                                            
                                    defaultValue=""
                                    name="arquivo"
                                    placeholder="Anexar Arquivo"
                                    type="file"
                                    onChange={handleAnexo}
                                />                                        
                            </FormGroup>
                        </Col>              
                    </Row>                       
                </div>
                <div className="modal-footer">
                <Button color="secondary" type="button" onClick={() => handleReturn()}>
                    Cancelar
                </Button>                
                <Button color="info" type="button" onClick={() => handleAddInconformidade()}>
                    Adicionar inconformidade
                </Button>                                
                </div>
            </Modal>
        </>
    );  
}
